import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'
import ShareIcon from 'material-ui/svg-icons/social/share'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode-react'
import qs from 'qs'
import { wxConfig, backendConfig, homepageDir } from '../../../../constant/wxConfig'
import Background from '../../../components/Background'
import RecordCard from './RecordCard'
import './HomeView.scss'
// import './Canvas2Image'

class HomeView extends React.Component {
  static contextTypes = {
    initLogin: React.PropTypes.func,
    displayToast: React.PropTypes.func,
    clearToast:React.PropTypes.func,
    divToast:React.PropTypes.func,
    setShareInfos:React.PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      localId: undefined,
      isRecording: false,
      showCover: false,
      isShowDialog:false
    }

    this.startRecordFlag = false
  }

  componentDidUpdate(prevProps) {
    if (this.props.userOpenid && !prevProps.userOpenid) {
      this.context.setShareInfos({
        shareIcon:backendConfig.serverHost + '/official/share_icon.jpg',
        shareLink:homepageDir + '/user/' + this.props.userOpenid,
        shareTitle:'十年了，我想对汶川说——来听' + this.props.user.userInfo.nickname + '的表白'
      })
    }
  }

  startRecord = () => {
    var that = this
    wx.startRecord({
      success: function () {
        that.startRecordFlag = true
        that.count = 1
        const showMic = () => {
          that.context.divToast({
            toastIcon:<img
              style={{ padding:10 }}
              src={require('../../../components/svgs/mic.svg')} />,
            toastMessage:<span>
              {'已录音 ' + that.count + ' 秒'}
              <br/>
              {'最长可录60秒'}
              </span>
          })
        }
        showMic()
        that.countInterval = setInterval(() => {
          that.count = that.count + 1
          showMic()
        }, 1000)
      },
      cancel: function () {
        that.setState({ isRecording: false })
        alert('用户拒绝授权录音');
      }
    })

    wx.onVoiceRecordEnd({
      // 录音时间超过一分钟没有停止的时候会执行 complete 回调
      complete: function (res) {
        that.setState({ isRecording: false })
        that.finishRecord(res.localId)
        that.startRecordFlag = false
        alert('录音时间已超过一分钟，点击播放听听你的录音吧！')
      }
    });
  }

  finishRecord = (localId) => {
    this.setState({
      localId
    }, () => {
      try {
        clearInterval(this.countInterval)
        this.countInterval.close()
      } catch (error) {
      }
      this.context.clearToast()
    })
  }

  stopRecord = (saveFlag = true) => {
    var that = this
    wx.stopRecord({
      success: function (res) {
        if (saveFlag) {
          that.finishRecord(res.localId)
        }
      }
    });
    that.startRecordFlag = false
  }

  onTouchStart = (event) => {
    event.preventDefault();
    this.setState({ isRecording: true })
    this.startTime = new Date().getTime();
    // 延时后录音，避免误操作
    var that = this
    that.recordTimer = setTimeout(function () {
      that.startRecord()
    }, 300);
  }

  onTouchEnd = (event) => {
    event.preventDefault();
    this.setState({ isRecording: false })
    // 间隔太短
    if (new Date().getTime() - this.startTime < 300) {
      this.startTime = 0;
      try {
        clearTimeout(this.recordTimer)
        this.recordTimer.close()
      } catch (error) {
      }
      this.context.displayToast({
        toastMessage: '  录音时间太短啦  ',
        toastIcon: ''
      })
    } else {
      // 松手结束录音
      this.stopRecord()
    }
  }

  uploadVoice = (callBack) => {
    var that = this
    // if (that.state.isLogined) {
    wx.uploadVoice({
      localId: that.state.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: function (res) {
        var serverId = res.serverId; // 返回音频的服务器端ID
        fetch(backendConfig.serverHost + '/uploadVoice/' + serverId + '/' + that.props.userOpenid + '/' + that.count)
          .then(res => res.json())
          .then(res => {
            if (res.msg && res.msg === 'ok') {
              that.context.displayToast({
                toastMessage: '语音上传成功',
                toastIcon: '恭喜您！',
                callBack: callBack
              })
              that.props.dispatch({
                type: 'UPLOAD_VOICE_SUCCESS'
              })
            } else {
              that.context.displayToast({
                toastMessage: '语音上传失败',
                toastIcon: 'Bad News'
              })
            }

          })
      }
    });
    // } else {
    //   that.context.displayToast({
    //     toastMessage: '需要微信登录才可上传录音, 两秒后为您跳转微信登录',
    //     toastIcon: '',
    //     callBack: () => that.login('localId_is_' + that.state.localId)
    //   })
    // }
  }

  renderRecordButton = (isRecording) => (
    <div className='record-button'
      onTouchStart={this.onTouchStart}
      onTouchEnd={this.onTouchEnd}>
      {isRecording
        ? <img src={require('../../../components/svgs/record_button_1.svg')} className='home-record-button' />
        : <img src={require('../../../components/svgs/record_button.svg')} className='home-record-button' />}
    </div>
  )

  createPoster = () => {
    this.context.displayToast({
      toastMessage: '生成海报中...',
      toastDuration: 1000
    })
    document.getElementById('forward-qr-code').style.display = 'block'
    html2canvas(document.getElementById('forward-qr-code')).then(function (canvas) {
      document.getElementById('forward-qr-code').style.display = 'none'
      var canvasImgNode = document.getElementById('forward-canvas-img')
      canvasImgNode.className = 'home-qrcode-final-bg'
      canvasImgNode.appendChild(
        canvas
      );
      var convertedImage = Canvas2Image.convertToPNG(
        canvasImgNode.firstChild,
        750,
        1334
      )
      convertedImage.className = 'home-qrcode-bg'
      canvasImgNode.append(convertedImage);
      canvasImgNode.removeChild(canvas)
    });
  }

  renderForwardArea = () => (
    <div className='home-forward-area' >
      <RaisedButton label="生成海报"
        onClick={() => {
          // if (this.props.user.isRecorded) {
          this.createPoster()
          // } else {
          //   this.uploadVoice(this.createPoster)
          // }
        }}
        backgroundColor={'#ff7876'}
        labelColor={'white'}
        className="home-forward-button" />
      <RaisedButton label="立即转发"
        backgroundColor={'#24c1d1'}
        labelColor={'white'}
        className="home-forward-button"
        onClick={() => {
          // if (this.props.user.isRecorded) {
          this.setState({
            showCover: true
          })
          // } else {
          //   this.uploadVoice(() => {
          //     this.setState({
          //       showCover: true
          //     })
          //   })
          // }

        }} />
    </div>
  )

  renderRecordArea = () => {
    const { isRecording, localId, toastMessage } = this.state
    return (
      <div className='home-record-main'>
        <img
          onClick={() => {
            window.location.href = 'https://mp.weixin.qq.com/mp/homepage?__biz=MzI0NDI2NzI5Nw==&hid=20&sn=d476b990e5d10e255a296ad19d9fc172&scene=1&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.3+build(16D30)&version=12020810&lang=zh_CN&nettype=WIFI&ascene=0&session_us=gh_15e685f9a9cd&fontScale=100&pass_ticket=vrTcpW%2B9ZC9Dtby%2FG422XcSdk%2FPkrCWHpqG4Se1EJkA%3D&wx_header=1'
          }}
          className='home-know-more'
          src={require('../../../components/svgs/know_more.svg')}
        />
        <div className='home-qrcode-container' id='forward-qr-code' onClick={() => {
          document.getElementById('forward-qr-code').style.display = 'none'
        }}>
          <div className='home-qrcode-nickname' >
            <span style={{ color: 'rgb(36, 193, 209)', marginRight: 2 }} >{this.props.user.userInfo.nickname}</span>
            的汶心表白
          </div>
          <div className='home-qrcode-qr'  >
            <QRCode
              size={64}
              value={homepageDir + '/user/' + this.props.userOpenid} />
          </div>
          <img className='home-qrcode-bg'
            src={require('../../../components/images/poster.png')} />
        </div>
        <div id='forward-canvas-img' className='home-qrcode-canvas' onClick={() => {
          document.getElementById('forward-canvas-img').innerHTML = null
          document.getElementById('forward-canvas-img').className = 'home-qrcode-canvas'
        }} >
        </div>
        <RecordCard
          localId={localId}
          user={this.props.user}
          refreshLocalId={() => {
            this.setState({ localId: undefined })
          }} />
        {
          (this.props.user.isRecorded)
            ? this.renderForwardArea()
            : (localId ? this.renderUploadButton()
              : this.renderRecordButton(isRecording)
            )
        }
      </div >
    )
  }

  renderUploadButton = () => (
    <div className='record-button'
      onClick={() => {
        this.setState({
          isShowDialog:true
        })
      }} >
      <img src={require('../../../components/svgs/upload_rightnow.svg')} className='home-record-button' />
    </div>
  )

  renderPleaseLogin = () => (
    <div className='home-record-main' style={{ marginTop: '70vh', color: '#24c1d1' }} >
      请点击下方登录按钮后再操作
      <RaisedButton label="微信登录"
        backgroundColor={'#24c1d1'}
        labelColor={'white'}
        style={{ marginTop: 10 }}
        onClick={this.context.initLogin}
        className="home-forward-button" />

    </div>
  )

  handleClose = () => {
    this.setState({
      isShowDialog:false
    })
  }

  renderDialog = () => (
    <Dialog
        actions={[<FlatButton
          label="再考虑考虑"
          primary={false}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="确认上传"
          primary={true}
          onClick={() => {
            this.handleClose()
            this.uploadVoice()
          }}
        />]}
        modal={false}
        open={this.state.isShowDialog}
        onRequestClose={this.handleClose}
      >
      音频只能上传一次，请确定满意后再上传噢
    </Dialog>
  )

  render = () => {
    const { userOpenid } = this.props
    const { showCover } = this.state
    return (
      <div className='main-container'>
        {this.renderDialog()}
        <Background pandaStyle={{ top: '0%', width: '100%' }} hideTitle={true} />
        <div className='home-record-bottom' >
        </div>
        {userOpenid ? this.renderRecordArea() : this.renderPleaseLogin()}

        {showCover && (
          <div
            className='container-cover'
            onClick={() => {
              this.setState({ showCover: false })
            }} >
            <img
              className='cover-img-pic'
              src={require('../../../components/svgs/share.svg')} />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    userOpenid: state.user.userOpenid
  }
}

export default connect(mapStateToProps, null)(HomeView)



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js